<template>
  <div class="w-full relative">
    <ul class="flex flex-col md:flex-row w-full items-stretch p-1 bg-gray-100 rounded-lg shadow-inner relative">

      <!-- Slider -->
      <div v-if="items.length > 0" class="absolute bg-white rounded-md shadow transition-all duration-300 ease-out" :style="sliderStyle"></div>

      <!-- Items -->
      <li v-for="(item, index) in items" :key="index" class="flex-1 text-center relative z-10 w-full" @click="selectItem(index)" >
        <span class="block w-full py-2 text-sm transition-all font-medium cursor-pointer" :class="activeIndex === index ? 'text-gray-800' : 'text-gray-500'">
          {{ item }}
        </span>
      </li>

    </ul>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';

export default defineComponent({
  data() {
    return {
      itemSelected: '',
      isMobile: window.innerWidth < 768
    }
  },
  props: {
    items: {
      type: Array as PropType<string[]>,
      required: true,
      default: () => []
    },
    onChange: {
      type: Function,
      required: false
    }
  },

  computed: {
    activeIndex(): number {
      const index = this.items.indexOf(this.itemSelected);
      return index !== -1 ? index : 0;
    },
    itemWidth(): number {
      return this.items.length > 0 ? 100 / this.items.length : 100;
    },
    itemHeight(): number {
      return this.items.length > 0 ? 100 / this.items.length : 100;
    },
    sliderStyle(): any {
      if (this.isMobile) {
        return {
          height: `calc(${this.itemHeight}% - 4px)`,
          width: 'calc(100% - 4px)',
          top: `calc(${this.activeIndex * this.itemHeight}% + 2px)`,
          left: '2px'
        };
      } else {
        return {
          width: `calc(${this.itemWidth}% - 4px)`,
          left: `calc(${this.activeIndex * this.itemWidth}% + 2px)`,
          top: '2px',
          bottom: '2px'
        };
      }
    }
  },

  methods: {
    selectItem(index: number) {
      this.itemSelected = this.items[index];
      if (this.onChange) {
        this.onChange(this.itemSelected, index);
      }
    },
    handleResize() {
      this.isMobile = window.innerWidth < 768;
    }
  },
  mounted() {
    if (this.items.length > 0) {
      this.itemSelected = this.items[0];
    }
    window.addEventListener('resize', this.handleResize);
  },

  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }
});
</script>